import React from 'react'
import {useSelector} from 'react-redux'
import {selectBuildingsByActiveOrganization} from '../../reducers/selectors'
import {generatePath, useHistory} from 'react-router-dom'
import Routes from '../../constants/RouteConstants'
import {makeStyles} from '@mui/styles'
import {Typography, Spacing} from '../../assets/styles'
import {rxrLightTint, rxrWhiteColor} from '../../assets/styles/color'
import {pluralizeWord} from '../../Utils/StringFormatter'

function GlobalAdminDashboard(props) {
  const classes = useStyles()
  const activeOrganization = useSelector(state => state.GlobalAdmin.organizationsLookup[state.GlobalAdmin.activeOrganizationId])
  const buildingsInOrg = useSelector(selectBuildingsByActiveOrganization)
  const documentsByBuilding = useSelector(state => state.GlobalAdmin.documentsByBuilding)
  const history = useHistory()

  return (
    <div className={classes.container}>
      <h1 style={Typography.AppBarHeaderAdmin}>{activeOrganization.displayName}</h1>
      <h3 style={Typography.H3Header}>Global Admin Dashboard</h3>

      <ul className={classes.buildingList}>
        {buildingsInOrg.map(b => (
          <li
            key={b.id}
            onClick={() => history.push(generatePath(Routes.ADMIN_DASHBOARD_DOCUMENTS_BY_BUILDING_VIEW_SINGLE, {buildingId: b.id}))}
          >
            <h5>{b.displayName}</h5>
            <div>
              <span className={classes.pill}>
                {pluralizeWord('Document', documentsByBuilding[b.id] ? documentsByBuilding[b.id].length : 0, true)}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    padding: Spacing.spaceMedium,
  },
  buildingList: {
    marginTop: Spacing.spaceMedium,
    display: 'flex',
    gap: Spacing.spaceMedium,

    '& li': {
      backgroundColor: rxrWhiteColor,
      borderRadius: 8,
      border: `1px solid ${theme.palette.primary.main}`,
      padding: Spacing.spaceMedium,
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',

      '&:hover': {
        backgroundColor: rxrLightTint,
      },

      '& h5': {
        fontSize: Typography.fontSizeLarge,
        marginBottom: Spacing.spaceSmall,
      },
    },
  },
  pill: {
    display: 'inline-block',
    padding: `${Spacing.spaceExtraExtraSmall}px ${Spacing.spaceExtraSmall}px`,
    borderRadius: Spacing.spaceExtraSmall,
    backgroundColor: theme.palette.primary.main,
    color: rxrWhiteColor,
    fontSize: Typography.fontSizeSmall,
  },
}))

export default GlobalAdminDashboard
